import * as styles from './styles';
import L from 'leaflet';

export const StartIcon = new L.DivIcon({
  html: `<div class="${styles.icon}" />`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export default StartIcon;
